import { Controller } from "@hotwired/stimulus";

// Thin launcher whose only job today is to fire an analytics event when the
// chat UI is rendered. Kept separate from the React component so that the
// future "modal launcher" entry point (Phase 2) can reuse the same data hooks.
export default class extends Controller {
  static values = {
    sessionId: Number,
  };

  connect() {
    if (typeof window === "undefined" || !window.dataLayer) return;
    window.dataLayer.push({
      event: "onboarding_chat_loaded",
      onboarding_session_id: this.sessionIdValue || null,
    });
  }
}
